import { ChevronLeft, ChevronRight } from "lucide-react";

export function Pagination({ page, total, pageSize, onChange }) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  if (total <= pageSize) return null;
  const start = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, total);
  const btn = "flex h-9 w-9 items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-600 transition-colors hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-40";
  return (
    <div className="mt-6 flex items-center justify-between" data-testid="pagination">
      <p className="text-sm text-slate-500">
        <span className="font-medium text-slate-700">{start}-{end}</span> / {total} kayıt
      </p>
      <div className="flex items-center gap-2">
        <button type="button" disabled={page <= 1} onClick={() => onChange(page - 1)} data-testid="page-prev" className={btn}>
          <ChevronLeft className="h-4 w-4" />
        </button>
        <span className="px-2 text-sm text-slate-600">Sayfa {page} / {totalPages}</span>
        <button type="button" disabled={page >= totalPages} onClick={() => onChange(page + 1)} data-testid="page-next" className={btn}>
          <ChevronRight className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
